/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NFLRedzoneAdvantagePageRushingQueryVariables = {|
  teamIds?: ?$ReadOnlyArray<?string>,
  minRsh?: ?number,
  seasonID?: ?string,
|};
export type NFLRedzoneAdvantagePageRushingQueryResponse = {|
  +nflRedzoneRushingStats: ?$ReadOnlyArray<?{|
    +player: {|
      +firstName: string,
      +lastName: string,
      +position: {|
        +name: ?string
      |},
      +team: ?{|
        +logoSrc: ?string
      |},
    |},
    +rushes: number,
    +fumbles: number,
    +touchdowns: number,
  |}>
|};
export type NFLRedzoneAdvantagePageRushingQuery = {|
  variables: NFLRedzoneAdvantagePageRushingQueryVariables,
  response: NFLRedzoneAdvantagePageRushingQueryResponse,
|};
*/


/*
query NFLRedzoneAdvantagePageRushingQuery(
  $teamIds: [ID]
  $minRsh: Int
  $seasonID: ID
) {
  nflRedzoneRushingStats(teamIds: $teamIds, minRsh: $minRsh, seasonId: $seasonID) {
    player {
      firstName
      lastName
      position {
        name
        id
      }
      team {
        logoSrc
        id
      }
      id
    }
    rushes
    fumbles
    touchdowns
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minRsh"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seasonID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v3 = [
  {
    "kind": "Variable",
    "name": "minRsh",
    "variableName": "minRsh"
  },
  {
    "kind": "Variable",
    "name": "seasonId",
    "variableName": "seasonID"
  },
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoSrc",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rushes",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fumbles",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "touchdowns",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NFLRedzoneAdvantagePageRushingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NFLRedzoneRushingStatsType",
        "kind": "LinkedField",
        "name": "nflRedzoneRushingStats",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatPositionType",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatTeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "NFLRedzoneAdvantagePageRushingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NFLRedzoneRushingStatsType",
        "kind": "LinkedField",
        "name": "nflRedzoneRushingStats",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatPositionType",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatTeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3a6f96a03df1a6906e85c80552528ac",
    "id": null,
    "metadata": {},
    "name": "NFLRedzoneAdvantagePageRushingQuery",
    "operationKind": "query",
    "text": "query NFLRedzoneAdvantagePageRushingQuery(\n  $teamIds: [ID]\n  $minRsh: Int\n  $seasonID: ID\n) {\n  nflRedzoneRushingStats(teamIds: $teamIds, minRsh: $minRsh, seasonId: $seasonID) {\n    player {\n      firstName\n      lastName\n      position {\n        name\n        id\n      }\n      team {\n        logoSrc\n        id\n      }\n      id\n    }\n    rushes\n    fumbles\n    touchdowns\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e78cee3c822887112ffb924cfb402d7d';

module.exports = node;
